import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { monitoringTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { usePlatform } from "../../context/PlatformContext";

const MonitoringModulePage = ({ title, subtitle, children, dataMode = { mode: "real" } }) => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  const location = useLocation();
  const visibleMode = showMockData && ["/monitoring/live", "/monitoring/cameras"].includes(location.pathname) ? { mode: "mock" } : dataMode;
  return (
    <ModuleLayout compactHeader title={title} subtitle={subtitle} breadcrumbs={[t("platform.nav.monitoring"), title]} tabs={monitoringTabs} dataMode={visibleMode}>
      {children}
    </ModuleLayout>
  );
};

export default MonitoringModulePage;
